import apiInstance from "api";

/**
 * Subscription plan catalog + current plan + upgrade/downgrade endpoints.
 * Backed by flex2-api — see PlanCatalogSeedController for the seed data.
 *
 * Endpoints:
 *   GET  /api/financials/subscription-plans  → list all plans + feature entries
 *   GET  /api/user/plan                      → the caller's org active plan
 *   POST /api/user/plan/change               → request a plan change
 */
export const PlansApiService = {
  list: () => apiInstance.get(`/financials/subscription-plans`),
  current: (organizationId) =>
    apiInstance.get(`/user/plan`, { params: organizationId ? { organizationId } : {} }),
  changePlan: (targetPlanUuid) =>
    apiInstance.post(`/user/plan/change`, { targetPlanUuid }),
};

export default PlansApiService;
